@use "src/sedestral/sass/mixins/texts";
@use "src/sedestral/sass/icons/icons";

.componentWebsiteBlackFlowGrid {
  display: flex;
  flex-direction: column;
  color: var(--black);
  gap: 30px;

  .bigTitle {
    max-width: 900px;
    font-size: 28px;

    @include texts.font("semi-bold");
  }

  .description {
    font-size: 15px;
    max-width: 800px;
  }

  @media screen and (max-width: 930px) {
    .bigTitle {
      font-size: 22px !important;
    }
  }
}